import { t } from "@/i18n-js/instance";
import { useButtonVariant } from "@circle-react/helpers/useButtonVariant";
import { Button } from "@circle-react-uikit/Button";
import { Fieldset } from "@circle-react-uikit/Fieldset";
import { Form } from "@circle-react-uikit/Form";
import { useFilterContext } from "../Filter";

interface RadioFilterOption {
  [key: string]: any; // Allow additional properties like 'name'
  label: string;
  value: string;
}

interface RadioFilterProps {
  legend: string;
  name: string;
  options: RadioFilterOption[];
}

export const RadioFilter = ({ options, name, legend }: RadioFilterProps) => {
  const { selectedText, onApply } = useFilterContext();
  const primaryButtonVariant = useButtonVariant();

  const handleApply = (submitData: any, { reset }: any): void => {
    onApply(submitData[name]);
    reset();
  };

  return (
    <div className="min-w-[18rem] p-4">
      <Form defaultValues={{ [name]: selectedText }} onSubmit={handleApply}>
        <div className="flex flex-col gap-y-4">
          <Fieldset legend={legend} verticalSpacing="tight">
            <Form.Item
              name={name}
              hideLabel
              hideBorder
              hideDescription
              isFirstChild
            >
              <Form.RadioGroup variant="radio" options={options} name={name} />
            </Form.Item>
          </Fieldset>
          <Button variant={primaryButtonVariant} type="submit" full>
            {t("filters.apply")}
          </Button>
        </div>
      </Form>
    </div>
  );
};
